/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LdapSecurityConfiguration {
    None = 0,
    SSL = 1,
    TLS = 2,
}
